import Vue from 'vue'
export default {
    openNewTab (name, params) {
        const routeData = Vue.router.resolve({ name: name, params: params })
        window.open(routeData.href, '_blank')
    },
    async getBase64String(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                // replace the data: part depending on your need
                const base64String = reader.result.toString()/* .replace(/^data:(.*,)?/, '') */
                resolve(base64String)
            }
            reader.onerror = (error) => {
                reject(error)
            }
            reader.readAsDataURL(file)
        })
    },
}
